export default "__VITE_ASSET__49f80a46__"